var cov_rhm7fwt8p = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/styles/index.ts",
      hash = "21247bbf6732cf2a46377e1f319b187b83f1f13f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Spin/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 25
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "1": {
        start: {
          line: 20,
          column: 28
        },
        end: {
          line: 20,
          column: 67
        }
      },
      "2": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 58
        }
      },
      "3": {
        start: {
          line: 22,
          column: 26
        },
        end: {
          line: 22,
          column: 61
        }
      },
      "4": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 61
        }
      },
      "5": {
        start: {
          line: 24,
          column: 25
        },
        end: {
          line: 24,
          column: 58
        }
      },
      "6": {
        start: {
          line: 25,
          column: 32
        },
        end: {
          line: 25,
          column: 75
        }
      },
      "7": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 26,
          column: 78
        }
      },
      "8": {
        start: {
          line: 27,
          column: 29
        },
        end: {
          line: 27,
          column: 66
        }
      },
      "9": {
        start: {
          line: 28,
          column: 32
        },
        end: {
          line: 28,
          column: 75
        }
      },
      "10": {
        start: {
          line: 29,
          column: 32
        },
        end: {
          line: 29,
          column: 75
        }
      },
      "11": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 30,
          column: 75
        }
      },
      "12": {
        start: {
          line: 31,
          column: 29
        },
        end: {
          line: 31,
          column: 66
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var spinLess = {};
import genaration from '../../utils/classname';
var defaultLess = {};
var ringLess = {};
var planeLess = {};
var pulseLess = {};
var waveLess = {};
var chasingDotsLess = {};
var doubleBounceLess = {};
var cubeGridLess = {};
var chasingRingLess = {};
var scaleCircleLess = {};
var threeBounceLess = {};
var fourDotsLess = {};
export var spinClass = (cov_rhm7fwt8p.s[0]++, genaration(spinLess, 'spin'));
export var defaultClass = (cov_rhm7fwt8p.s[1]++, genaration(defaultLess, 'spin-default'));
export var ringClass = (cov_rhm7fwt8p.s[2]++, genaration(ringLess, 'spin-ring'));
export var planeClass = (cov_rhm7fwt8p.s[3]++, genaration(planeLess, 'spin-plane'));
export var pulseClass = (cov_rhm7fwt8p.s[4]++, genaration(pulseLess, 'spin-pulse'));
export var waveClass = (cov_rhm7fwt8p.s[5]++, genaration(waveLess, 'spin-wave'));
export var chasingDotsClass = (cov_rhm7fwt8p.s[6]++, genaration(chasingDotsLess, 'chasing-dots'));
export var doubleBounceClass = (cov_rhm7fwt8p.s[7]++, genaration(doubleBounceLess, 'double-bounce'));
export var cubeGridClass = (cov_rhm7fwt8p.s[8]++, genaration(cubeGridLess, 'cube-grid'));
export var chasingRingClass = (cov_rhm7fwt8p.s[9]++, genaration(chasingRingLess, 'chasing-ring'));
export var scaleCircleClass = (cov_rhm7fwt8p.s[10]++, genaration(scaleCircleLess, 'scale-circle'));
export var threeBounceClass = (cov_rhm7fwt8p.s[11]++, genaration(threeBounceLess, 'three-bounce'));
export var fourDotsClass = (cov_rhm7fwt8p.s[12]++, genaration(fourDotsLess, 'four-dots'));